import { defineMessages } from 'react-intl';

export const priceOptionLabel = {
  per_item: '/item',
  per_person: '/person',
  per_hour: '/hour',
  flat_fee: ' flat fee'
};

export const priceDisplayString = (currencySymbol, price, priceOptions) => {
  return `${currencySymbol}${Number(price || 0).toFixed(2)}${priceOptionLabel[priceOptions]}`;
};

const intlCollectVatCopy = defineMessages({
  vatCopy: {
    id: 'hosting.create_item_form.collect_vat_copy',
    defaultMessage: 'If you collect VAT, please include it in the price above.'
  },
  gstCopy: {
    id: 'hosting.create_item_form.collect_gst_copy',
    defaultMessage: 'If you collect GST, please include it in the price above.'
  },
  hstCopy: {
    id: 'hosting.create_item_form.collect_hst_copy',
    defaultMessage: 'If you collect HST, please include it in the price above.'
  },
  salesTaxCopy: {
    id: 'hosting.create_item_form.collect_sales_tax_copy',
    defaultMessage: 'If you collect sales tax, please include it in the price above.'
  }
});

const intlAddOnTaxTypeOptions = defineMessages({
  vat: {
    id: 'hosting.create_item_form.tax_type_vat_name',
    defaultMessage: 'VAT'
  },
  gst: {
    id: 'hosting.create_item_form.tax_type_gst_name',
    defaultMessage: 'GST'
  },
  gstHst: {
    id: 'hosting.create_item_form.tax_type_gst_hst_name',
    defaultMessage: 'GST/HST'
  },
  hst: {
    id: 'hosting.create_item_form.tax_type_hst_name',
    defaultMessage: 'HST'
  },
  pst: {
    id: 'hosting.create_item_form.tax_type_pst_name',
    defaultMessage: 'PST'
  },
  qst: {
    id: 'hosting.create_item_form.tax_type_qst_name',
    defaultMessage: 'QST'
  },
  rst: {
    id: 'hosting.create_item_form.tax_type_rst_name',
    defaultMessage: 'RST'
  },
  salesTax: {
    id: 'hosting.create_item_form.tax_type_sales_tax_name',
    defaultMessage: 'Sales Tax'
  },
  other: {
    id: 'hosting.create_item_form.tax_type_other_name',
    defaultMessage: 'Other'
  }
});

export const collectVatCopy = {
  VAT: intlCollectVatCopy.vatCopy,
  GST: intlCollectVatCopy.gstCopy,
  HST: intlCollectVatCopy.hstCopy,
  other: intlCollectVatCopy.salesTaxCopy
};

export const addOnTaxTypeOptions = {
  VAT: intlAddOnTaxTypeOptions.vat,
  GST: intlAddOnTaxTypeOptions.gst,
  gst_hst: intlAddOnTaxTypeOptions.gstHst,
  HST: intlAddOnTaxTypeOptions.hst,
  PST: intlAddOnTaxTypeOptions.pst,
  QST: intlAddOnTaxTypeOptions.qst,
  RST: intlAddOnTaxTypeOptions.rst,
  sales_tax: intlAddOnTaxTypeOptions.salesTax,
  other: intlAddOnTaxTypeOptions.other
}
